import { ComponentType, ComponentInstance } from "../../js/component";

class Header extends ComponentInstance {
  #open = false;
  #isMobile = window.matchMedia("(hover: none), (pointer: coarse)").matches;

  init() {
    this.toggleButton = this.el.querySelector(".navbar-toggle");
    if (!this.toggleButton) {
      return;
    }

    this.bindHandlers();

    this.#open = this.toggleButton.getAttribute("aria-expanded") === "true";

    this.toggleButton.addEventListener("click", this.onToggleClick);
    window.matchMedia('(max-width: 768px)').addEventListener('change', this.onResize, true);
  }

  bindHandlers() {
    this.onToggleClick = this.onToggleClick.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  onToggleClick() {
    this.isOpen = !this.isOpen;

    this.el.dispatchEvent(
      new CustomEvent('menubar:toggle', { detail: { expanded: this.isOpen } })
    );

  }

  setHeaderExpanded(value) {
    this.el.setAttribute('data-header-expanded', value.toString());
  }

  onResize(event) {
    this.#isMobile = event.matches;
  }

  set isOpen(value) {
    this.#open = Boolean(value);

    this.toggleButton.setAttribute("aria-expanded", String(this.#open));
    this.setHeaderExpanded(this.#open);
  }

  get isOpen() {
    return this.#open;
  }
}

new ComponentType(Header, "header", ".header");
